<template>
    <div class="content">
      <div @click="changePerson" v-if="$storage.get('patient')">
        <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;font-size: .3rem;">
          <el-col :span="8">
            <div style="height: 1rem;line-height: 1rem;margin-left: .3rem">当前就诊人：</div>
          </el-col>
          <el-col :span="13">
            <div style="height: 1rem;line-height: 1rem;">
              <span>{{$storage.get('patient').clinic_patient_name}}</span>
              <span style="float: right;color:#e02c06;font-weight: 700;font-size: .32rem">换人</span>
            </div>
          </el-col>
          <el-col :span="3">
            <div style="height: 1rem;line-height: 1.3rem;padding-left: .1rem;">
              <img src="static/img/huanren.png" style="width: .5rem;height: .5rem"/>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="$storage.get('patient')">
        <el-row class="content-line">
          <el-col :span="8" class="title">开始日期</el-col>
          <el-col :span="15" class="text">
            <el-date-picker v-model="startDate" type="date" placeholder="选择日期"></el-date-picker>
          </el-col>
        </el-row>
        <el-row class="content-line">
          <el-col :span="8" class="title">结束日期</el-col>
          <el-col :span="15" class="text">
            <el-date-picker v-model="endDate" type="date" placeholder="选择日期"></el-date-picker>
          </el-col>
        </el-row>
        <div style="width: 100%;text-align: center;margin-top: .6rem;">
          <el-button type="primary" style="width: 6rem;font-size: .32rem" @click="toSelect">立即查询</el-button>
        </div>
      </div>
      <div class="noCard" v-if="!$storage.get('patient')">
        <div class="noCard-img">
          <img src="static/img/noCard.png"/>
        </div>
        <div class="noCard-text">暂无数据</div>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
        return{
          startDate:'',
          endDate:'',
        }
      },
      created() {
        //修改标题
        document.title = '报告查询'
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        this.startDate=this.getDay(-7)
        this.endDate=year+'-'+month+'-'+strDate
      },
      methods:{
        changePerson(){
          this.$router.push({path:'/selectPerson'})
        },
        toSelect(){
          this.$router.push({path:'/report',query:{
              startDate:this.getDateYYMMDD(this.startDate),
              endDate:this.getDateYYMMDD(this.endDate)
            }})
        },
        //获取date的年-月-日
        getDateYYMMDD(date){
          let myDate = new Date(date)
          let yy = myDate.getFullYear();
          let mm = String((myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1))
          let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
          return yy + '-' +mm + '-' + dd
        },
        getDay(day){
          let today = new Date();
          let targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
          today.setTime(targetday_milliseconds); //注意，这行是关键代码
          let tYear = today.getFullYear();
          let tMonth = today.getMonth();
          let tDate = today.getDate();
          tMonth = this.doHandleMonth(tMonth + 1);
          tDate = this.doHandleMonth(tDate);
          return tYear+"-"+tMonth+"-"+tDate;
        },
        doHandleMonth(month){
          let m = month;
          if(month.toString().length == 1){
            m = "0" + month;
          }
          return m;
        }
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  .content-line{
    height: .8rem;
    background-color: #FFFFFF;
    margin-bottom: 1px;
  }
  .title{
    line-height: .8rem;
    margin-left: .3rem;
    color: #666666;
  }
  .text{
    line-height: .8rem;
    text-align: right;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/reportChange.vue